var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 40,
    viewBox: "0 0 80 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 40,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.6741 30.3372C50.5384 32.0625 43.4138 25.2969 45.2298 17.5724C46.1468 13.6766 49.4557 10.5337 53.5563 9.66305C61.6944 7.9365 68.8225 14.7057 67.0041 22.4316C66.0872 26.3256 62.7771 29.4678 58.6741 30.3372ZM26.4377 30.3372C18.3021 32.0625 11.1763 25.2969 12.9935 17.5724C13.9093 13.6766 17.2193 10.5337 21.32 9.66305C29.4569 7.9365 36.5862 14.7057 34.7678 22.4316C33.8508 26.3256 30.5408 29.4678 26.4377 30.3372ZM76.1247 13.7807C73.362 5.79104 65.4433 0 56.1164 0C56.1164 0 42.8892 0.563831 39.9988 0.563831C37.1108 0.563831 23.88 0 23.88 0C14.5543 0 6.63569 5.79104 3.87292 13.7807C1.73973 13.7909 0 15.4495 0 17.4772V22.5245C0 24.5513 1.73973 26.2092 3.87292 26.2198C6.63569 34.21 14.552 40 23.88 40C28.7772 40 33.2868 38.4013 36.8676 35.7274C38.7253 34.3405 41.2735 34.3405 43.13 35.7279C46.7096 38.4022 51.218 40 56.1164 40C65.4433 40 73.362 34.21 76.1247 26.2198C78.2567 26.2092 80 24.5513 80 22.5245V17.4772C80 15.4495 78.2567 13.7909 76.1247 13.7807Z",
    fill: "#80CC28"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ea538f15247c34c150dbcbd763c7cb02.svg";
export { ForwardRef as ReactComponent };